<template>
  <v-dialog
    v-model="dialog"
    lazy
    hide-overlay
    transition="dialog-bottom-transition"
    width="600px"
  >
    <v-card class="terms-modal">
      <div class="terms-head">
        <div class="terms-head__icon"><v-icon color="white">description</v-icon></div>
        <span class="terms-head__title">Termos de Serviço</span>
      </div>
      <v-card-text class="text-sm-left terms-body">
        <p>
          TERMO DE ADESÃO AO CONTRATO DE CESSÃO DE CRÉDITOS E CONDIÇÕES
          COMERCIAIS DE CESSÃO {{ appName }} SERVIÇOS DO BRASIL LTDA. ("{{ appName }}"),
          sociedade empresária limitada, inscrita no CNPJ/MF sob o nº
          10.344.530/0001-00, com sede na Av. Roque Petroni Junior, nº 1.089, 9º
          andar, conj. 911, bairro Jardim das Acácias, CEP 04.707-900, no
          Município de São Paulo, Estado de São Paulo, se dedica à prestação de
          serviços de realização de OPERAÇÕES através de meios de pagamento
          eletrônicos, incluindo cartões de crédito e débito, vem, por meio
          deste Instrumento, instituir cláusulas e condições para o aceite ao
          Contrato de Cessão de Créditos e às Condições Comerciais de Cessão,
          nos termos havidos neste Termo de Adesão ao Contrato de Cessão de
          Créditos ("TAC") e, por decorrência, às Condições Comerciais de
          Cessão, o que implicará a Antecipação de Recebíveis Líquidos ("ARL"),
          registrado sob o microfilme nº 5.349.477 em 18 de Julho de 2018 no 4º
          Oficial de Registro de Título e Documentos e Civil de Pessoa Jurídica
          do Município de São Paulo, Estado de São Paulo.
        </p>
        <p><b>1. ESTABELECIMENTO</b></p>
        <p>
          &emsp;1.1. O ESTABELECIMENTO que aderir ao Contrato de Cessão de
          Créditos concorda com as Condições Comerciais de Cessão,concordando
          com as seguintes taxas e valores de Preço de Cessão:
        </p>
        <p>&emsp;&emsp;Descrição do Serviço: Cessão de Créditos</p>
        <p>
          &emsp;&emsp;Taxa de Desconto Mensal (%): De acordo com a taxa do dia
        </p>
        <p>
          <b
            >2. VALIDADE DESTA PROPOSTA COMERCIAL DE CESSÃO E TERMO DE ADESÃO</b
          >
        </p>
        <p>
          &emsp; 2.1. A Proposta Comercial e Termo de Adesão ao Contrato de
          Cessão de Créditos são válidos por 10 (dez) dias, contados da data da
          emissão pela {{ appName }}.
        </p>
        <p>
          &emsp; 2.2. Após assinatura do Termo de Adesão ao Contrato de Cessão
          de Créditos e a essas Condições Comerciais de Cessão, o mesmo será
          valido por tempo indeterminado ou até que todos os créditos objeto da
          Cessão sejam efetivamente recebidos financeiramente pela {{ appName }}.
        </p>
        <p><b>3. TERMO DE ADESÃO</b></p>
        <p>
          &emsp; 3.1. Este Termo de Adesão, juntamente com as Condições
          Comerciais de Cessão de Créditos integrarão o CONTRATO de prestação de
          serviços entre a {{ appName }} e o ESTABELECIMENTO, que neste ato declara que
          tem total conhecimento do conteúdo de referido CONTRATO, bem como de
          todos os seus termos e condições e os aceita, aderindo, desta forma, a
          todas as suas condições, integralmente.
        </p>
      </v-card-text>
      <v-card-actions class="terms-actions">
        <a
          class="terms-pdf"
          :href="`https://s3.amazonaws.com/flow-it/Termos_de_Adesao_Antecipacao_${appName}.pdf`"
          target="_blank"
        >
          <v-icon small>picture_as_pdf</v-icon> Baixar Termo em PDF</a
        >
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" flat round @click="cancel()">Recusar</v-btn>
        <v-btn color="primary" round depressed @click="accepted()">Aceitar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "@/services/event-bus";

export default {
  name: "AutomaticAnticipationTerms",
  created() {
    this.$store.dispatch("system/fetchSystemConfiguration");
  },
  computed: {
    ...mapGetters({
      rule: "user/automaticAnticipationEnabled",
      systemAppName: "system/appName",
    }),
    appName() {
      return this.systemAppName || process.env.VUE_APP_APP_NAME || 'FlowIt';
    },
  },
  beforeCreate() {
    EventBus.$on("anticipation.terms.modal.show", () => {
      this.dialog = true;
    });
  },
  methods: {
    ...mapActions({
      requestAnticipation: "user/requestAnticipation",
      cancelAutomaticAnticipationProccess:
        "user/cancelAutomaticAnticipationProccess",
    }),
    cancel() {
      this.cancelAutomaticAnticipationProccess();
      this.dialog = false;
      window.location.reload();
    },
    accepted() {
      // Accepting the terms drops an activation request in the backoffice queue.
      this.requestAnticipation("automatic_on");
      this.dialog = false;
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
};
</script>

<style scoped>
.terms-modal {
  border-radius: 20px !important;
  overflow: hidden;
}

.terms-head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 22px;
  border-bottom: 1px solid #eef1f5;
}

.terms-head__icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #5b8def, #2f6fe0);
  box-shadow: 0 6px 14px rgba(47, 111, 224, 0.32);
}

.terms-head__title {
  font-size: 18px;
  font-weight: 700;
  color: #1f2933;
}

.terms-body {
  max-height: 60vh;
  overflow-y: auto;
  font-size: 13px;
  line-height: 1.55;
  color: #4b5563;
}

.terms-actions {
  padding: 12px 20px 18px !important;
  border-top: 1px solid #eef1f5;
}

.terms-pdf {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
}
</style>

